import axios from "axios";
import { toast } from "react-toastify";
import { LOGIN_USER } from "../../types/UserType";
import { Navigate } from "react-router-dom";

const addUserAction = (data) => {
	return {
		type: LOGIN_USER,
		payload: data,
	};
};

export const addUser = (values) => {
	return async (dispatch) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `user/login`,
				data: {
					...values,
				},
			});
			//dispatching data
			dispatch(addUserAction(data));
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("role", data.role);
			localStorage.setItem("user", data.username);
			localStorage.setItem("id", data.id);
			if (data.company_id != null) localStorage.setItem("company_id", data.company_id);
			localStorage.setItem("isLogged", true);
			localStorage.setItem("isRequired", data.isRequired ? "true" : "false");
			
			if (data.isRequired) {
				toast.info("Please change your password to continue.");
				return { success: "success", isRequired: true };
			} else {
				toast.success(" Login Successfully Done");
				return { success: "success", isRequired: false };
			}
		} catch (error) {
			console.log(error.message);
			toast.error("Incorrect Username or Password !");
			return "error";
		}
	};
};
